import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';

export function useGetDays(selectedWeek: {
  selectedDay: Dayjs;
  start: Dayjs;
  end: Dayjs;
}) {
  const { t } = useTranslation();

  return useMemo(() => {
    const selectedStyle = {
      backgroundColor: '#DDEFFF',
      margin: '-24px -28px',
      padding: '24px 28px',
      color: 'var(--primary)',
    };
    const dayOfWeek = selectedWeek.selectedDay.day();
    return [
      {
        id: 'Lu',
        headerTitle: (
          <div style={dayOfWeek === 1 ? selectedStyle : {}}>
            <div className="d-flex align-left" style={{ fontSize: '24px' }}>
              {selectedWeek.start.format('D')}
            </div>
            <div className="d-flex align-left fs-16">{t('common.days.Lu')}</div>
          </div>
        ),
      },
      {
        id: 'Ma',
        headerTitle: (
          <div style={dayOfWeek === 2 ? selectedStyle : {}}>
            <div className="d-flex align-left" style={{ fontSize: '24px' }}>
              {selectedWeek.start.add(1, 'd').format('D')}
            </div>
            <div className="d-flex align-left fs-16">{t('common.days.Ma')}</div>
          </div>
        ),
      },
      {
        id: 'Mi',
        headerTitle: (
          <div style={dayOfWeek === 3 ? selectedStyle : {}}>
            <div className="d-flex align-left" style={{ fontSize: '24px' }}>
              {selectedWeek.start.add(2, 'd').format('D')}
            </div>
            <div className="d-flex align-left fs-16">{t('common.days.Mi')}</div>
          </div>
        ),
      },
      {
        id: 'Ju',
        headerTitle: (
          <div style={dayOfWeek === 4 ? selectedStyle : {}}>
            <div className="d-flex align-left" style={{ fontSize: '24px' }}>
              {selectedWeek.start.add(3, 'd').format('D')}
            </div>
            <div className="d-flex align-left fs-16">{t('common.days.Ju')}</div>
          </div>
        ),
      },
      {
        id: 'Vi',
        headerTitle: (
          <div style={dayOfWeek === 5 ? selectedStyle : {}}>
            <div className="d-flex align-left" style={{ fontSize: '24px' }}>
              {selectedWeek.start.add(4, 'd').format('D')}
            </div>
            <div className="d-flex align-left fs-16">{t('common.days.Vi')}</div>
          </div>
        ),
      },
      {
        id: 'Sa',
        headerTitle: (
          <div style={dayOfWeek === 6 ? selectedStyle : {}}>
            <div className="d-flex align-left" style={{ fontSize: '24px' }}>
              {selectedWeek.start.add(5, 'd').format('D')}
            </div>
            <div className="d-flex align-left fs-16">{t('common.days.Sa')}</div>
          </div>
        ),
      },
      {
        id: 'Do',
        headerTitle: (
          <div style={dayOfWeek === 0 ? selectedStyle : {}}>
            <div className="d-flex align-left" style={{ fontSize: '24px' }}>
              {selectedWeek.end.format('D')}
            </div>
            <div className="d-flex align-left fs-16">{t('common.days.Do')}</div>
          </div>
        ),
      },
    ];
  }, [selectedWeek, t]);
}
